module.exports = __webpack_public_path__ + "static/media/ends_with_p.13ba724a.mp3";